import React, { useEffect, useState } from 'react';
import CustomInput from "../../components/UI/customInput/customInput";
import CustomButton from "../../components/UI/customButton/customButton";
import { useTranslation } from "react-i18next";
import VisaTable from "../../components/table/visa-table";
import { Get, Post } from "../../apis/api";
import { toast } from "react-toastify";
import CustomSelect from "../../components/UI/customSelect/customSelect";
import { CustomSwitch } from "../../components/UI/customSwitch/customSwitch";
import { CustomMultiSelect } from '../../components/UI/customMultiSelect/customMultiSelect';
import { useDocuments } from './Documents/hooks/index'

const VisaSection = () => {
  const { t } = useTranslation();
  const [form, setForm] = useState({})
  const [open, setOpen] = useState(false)

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [visas, setVisas] = useState([])
  const [editId, setEditId] = useState(null)

  const { data: documentData, isLoading } = useDocuments()



  const handleForm = ({ name, value }) => {
    setForm((prevState) => ({ ...prevState, [name]: value }))
  }

  const type = [
    { id: "Extension for 6 months", name: "Extension for 6 months" },
    { id: "Obtaining for 6 months", name: "Obtaining for 6 months" },
    { id: "Final exit", name: "Final exit" },
    { id: "72-hour_accession_departure ", name: "72-hour_accession_departure " },
    { id: "72-hour_accession_entry ", name: "72-hour_accession_entry " },
    { id: "Extension for 3 months", name: "Extension for 3 months" },
    { id: "Obtaining for 3 months", name: "Obtaining for 3 months" },
  ]

  const handleSubmit = () => {
    setLoading(true)
    Post(`basic-information/visa/${editId ? `update/${editId}` : "store"}`, {
      ...(booleanFields.reduce((pv, cv) => pv = { ...pv, [cv]: 0 }, {})),
      ...form,
      related_visas: form?.related_visas?.map(i => i?.value),
      documents: form?.documents?.map(i => ({ document_id: i?.value })),
      "form": editId ? "update_form" : "store_form"
    }).then((res) => {
      toast.success(res.msg)
      setData(res?.details?.data)
      setOpen(false)
    }).catch((error) => {
      toast.error(error.message)
    })
      .finally(() => {
        setLoading(false)
      })
  }



  useEffect(() => {

    Get(`basic-information/visa?page=${1}&per_page=100`).then((res) => {
      setVisas(res?.details?.data)
    }).finally(() => {
      setLoading(false)
    })

  }, [])


  const handleEdite = (e) => {
    setOpen(true)
    const booleanFieldsObj = booleanFields.reduce((pv, cv) => ({ ...pv, [cv]: !!e[cv] ? 1 : 0 }), {})
    setForm({
      "fa_name": e["fa_name"], "en_name": e["en_name"], "price": e["price"], "visa_type": e["visa_type"],
      "related_visas": e?.["related_visas"]?.map(i => ({ value: i?.related_visa_id, label: i?.related_visa?.fa_name })),
      "documents": e?.["documents"]?.map(i => ({ value: i?.id, label: i?.title })),
      ...booleanFieldsObj
    })
    setEditId(e.id)
  }
  const handleClose = () => {
    setOpen(false)
    setForm({})
    setEditId(null)
  }

  const booleanFields = ['duplicate', 'need_exit_dock', 'need_fly', 'need_otb', 'need_dock_and_ships', 'residence', 'need_crew', 'need_exit_date', 'need_command_letter']

  // useEffect(() => {
  //   if (visas?.data && form?.related_visas?.filter(i => !!i?.label).length == 0)
  //     handleForm({ name: 'related_visas', value: e?.related_visas.map(i => ({ ...i, label: visas.data.find(d => d.id == i)?.label })) })
  // }, [e?.related_visas, visas.data])

  return (
    <div className={"flex flex-col w-full pb-32"}>
      <div onClick={(e) => e.target === e.currentTarget && handleClose()} className={`fixed top-0 right-0 bg-modal h-full w-full z-50 flex justify-center items-center ${open ? "flex" : "hidden"}`}>
        <div className={" bg-white rounded-lg p-5 flex flex-col items-center max-w-[350px] max-h-[90vh] overflow-auto"}>
          <div className={"text-gray-500 text-base"}>
            {t("titleVisa")}
          </div>
          <div className={"grid grid-cols-1  mt-5 justify-between gap-5 w-full "}>
            <CustomInput
              placeHolder={t("visaNameFa")}
              label={t("visaNameFa")}
              name={"fa_name"}
              defaultValue={form["fa_name"]}
              onchange={(e) => handleForm(e)}
            />
            <CustomInput
              placeHolder={t("visaNameEn")}
              label={t("visaNameEn")}
              name={"en_name"}
              defaultValue={form["en_name"]}
              onchange={(e) => handleForm(e)}
            />
            <CustomInput
              separate={true}
              placeHolder={t("price")}
              label={t("price")}
              name={"price"}
              defaultValue={form["price"]}
              onchange={(e) => handleForm(e)}
            />
            <CustomSelect
              name="visa_type"
              label={t("formType")}
              options={type}
              defaultValue={{ id: form["visa_type"], name: form["visa_type"] }}
              onchange={(e) => handleForm(e)}
            />

            <div className='flex flex-col justify-between gap-2 items-stretch'>
              <span className='text-gray-700 text-right text-sm'>{t('relatedVisa')}</span>

              {visas?.data && <CustomMultiSelect

                options={visas?.data?.map(i => ({ label: i?.['fa_name'], value: i?.id }))}
                // options={[
                //   { label: "Grapes 🍇", value: "grapes" },
                //   { label: "Mango 🥭", value: "mango" },
                //   { label: "Strawberry 🍓", value: "strawberry", disabled: true },
                // ]}
                isLoading={loading}
                selected={form?.['related_visas'] ?? []}
                setSelected={(selected) => handleForm({ name: 'related_visas', value: selected })}

              />}
            </div>


            <div className='flex flex-col justify-between gap-2 items-stretch'>
              <span className='text-gray-700 text-right text-sm'>{t('documentsTitle')}</span>

              {documentData?.details?.data && <CustomMultiSelect

                options={documentData?.details?.data?.data?.map(i => ({ label: i?.title, value: i?.id }))}
                // options={[
                //   { label: "Grapes 🍇", value: "grapes" },
                //   { label: "Mango 🥭", value: "mango" },
                //   { label: "Strawberry 🍓", value: "strawberry", disabled: true },
                // ]}
                isLoading={loading}
                selected={form?.['documents'] ?? []}
                setSelected={(selected) => handleForm({ name: 'documents', value: selected })}

              />}
            </div>


            {booleanFields.map(item => <label className='flex flex-row gap-2 items-center justify-between cursor-pointer text-gray-900 text-sm'>
              <span>{t(item)}</span>
              <CustomSwitch
                name={item}
                onchange={(e) => handleForm(e)}
                checked={!!form[item]}
              />
            </label>
            )}

            <CustomButton loading={loading} onClick={handleSubmit} title={t("save")} />
          </div>
        </div>
      </div>
      <div className={"flex justify-end gap-5 w-full my-container"}>
        <div className={"w-[207px]"}>
          <CustomButton onClick={() => setOpen(true)} title={t("newVisa")} />
        </div>
      </div>
      <div>
        <VisaTable defaultValue={data} editItem={(e) => handleEdite(e)} />
      </div>
    </div>
  );
};

export default VisaSection;
